
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('BTN_Stop')]),_c('circle',{staticClass:"cls-2",attrs:{"cx":"400","cy":"400","r":"330"}}),_c('rect',{staticClass:"cls-1",attrs:{"x":"267.5","y":"267.5","width":"265","height":"265","rx":"16.67","ry":"16.67"}}),_c('path',{attrs:{"id":"circle","fill":"none","stroke":"currentColor","stroke-width":"70","stroke-dasharray":"2294","stroke-dashoffset":"2294","transform":"scale(-1 1) translate(-800 0) rotate(90 400 400)","d":"M35,400a365,365 0 1,0 730,0a365,365 0 1,0 -730,0"}})])
          )
        }
      }
    